import { useNavigate } from "react-router-dom";
import Not from "../../../assets/images/404.png";
import { useLanguage } from "../../../utils/useLanguage";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  return (
    <div className="flex flex-col gap-3 h-[calc(100vh-150px)] items-center justify-center px-4">
      <img src={Not} alt="" />
      <div className="items-center font-medium text-lg">
        {t("ui.notFound.title")}
      </div>
      <div className="text-center font-normal capitalize">
        {t("ui.notFound.message")}{" "}
        <span className="text-[#FA8151]" onClick={() => navigate("/home")}>
          {t("ui.notFound.homepage")}
        </span>{" "}
        {t("ui.notFound.or")}{" "}
        <span className="text-[#FA8151]" onClick={() => navigate("/help")}>
          {t("ui.notFound.contactUs")}
        </span>
      </div>
    </div>
  );
};

export default NotFound;
